import Styles from 'openspace/assets/styles/TextStyles.module.scss'
import { MenuOptions } from 'openspace/components/TopBar/TopBar.types'
import { RarumIntlShape } from './pt'

const messages: {
  'es-ES': RarumIntlShape
} = {
  'es-ES': {
    translations: {
      flowRequirements: {
        steps: {
          personalData: {
            title: 'Datos personales',
            questions: {
              name: 'Nombre completo',
              email: 'Correo electrónico',
              birthDate: 'Fecha de nacimiento',
              phone: 'Teléfono',
              document: 'CPF',
              documentForeign: 'Documento',
              isForeign: '',
              confirm:
                'Acepto compartir mis datos con <b>({{gallery}})</b> con fines de marketing',
            },
            error: {
              invalidCPF: 'Documento inválido',
            },
          },
          address: {
            title: 'Dirección',
          },
          kyc: {
            title: 'Validación de datos',
            loading: 'Estamos validando tus datos',
            rejected: {
              title: 'Ups, algo salió mal',
              description:
                'Por favor, revisa tus datos con atención e intenta nuevamente',
            },
            approved: {
              title: '¡Todo listo!',
              description: '¡Tus datos han sido validados!',
            },
            progress: {
              sendingData: 'Iniciando validación de tus datos',
              waitingReturn:
                'Esperando confirmación de datos - puedes salir de esta pantalla si lo necesitas',
            },
          },
        },
        standalone: {
          hi: 'Hola, {{name}}',
          to: {
            claim: {
              title: 'Completa el registro para continuar con el reclamo',
              action: 'Reclamar',
              loading: 'Por favor espera, estamos procediendo con el reclamo',
            },
            'marketplace-buy': {
              title:
                'Completa los siguientes datos para continuar con la verificación',
              action: '$t(generic.continue)',
              loading: 'Por favor, espera',
            },
            'marketplace-sell': {
              title: '$t(flowRequirements.standalone.to.marketplace-buy.title)',
              action:
                '$t(flowRequirements.standalone.to.marketplace-buy.action)',
              loading:
                '$t(flowRequirements.standalone.to.marketplace-buy.loading)',
            },
          },
        },
      },
      forum: {
        postedAt: 'Publicado hace {{time}}',
        noItems:
          '¿Tienes preguntas? \nUtiliza el campo de arriba y sé el primero en preguntar',
        post: {
          placeholder: 'Escribe tu pregunta aquí',
          cancelConfirmation: '¿Quieres descartar el mensaje escrito?',
          loggedOutUser: 'Hola, es necesario iniciar sesión para interactuar',
          actions: {
            cancel: 'Cancelar',
            post: 'Publicar',
          },
        },
        actions: {
          reply: 'Responder',
        },
      },
      offerDetails: {
        goal: 'Meta',
        minInvestment: 'Inversión mínima',
        minInvestmentShort: 'Inv. mínima',
        investors: 'Investors',
        reachedPrice: 'Total raised',
        beTheFirstToInvest: 'Be the first to invest',
        receivable: {
          soldUnits: 'Total sold',
          availability: 'Availability',
          expiration: 'Expiration',
          sold: 'Sold',
        },
        cvm: {
          performance: '{{performance}} per year',
          types: {
            equity: 'Equity',
            fixed: 'Fixed income',
            receivable: 'Receivables',
          },
        },
        goalReached: '{{percent}}% de la meta alcanzada',
        goalReached_0: 'No hay cuotas reservadas en este momento',
        goalReached_beyond: 'Meta alcanzada',
        sold: '{{percent}}% vendido',
        sold_0: 'Sin ventas',
        sold_beyond: 'Meta alcanzada',
        limit: 'Límite',
        timeRemaining: 'TIEMPO RESTANTE',
        offer: 'OFERTA',
        preMoneyValuation: 'VALORACIÓN PREVIA',
        companyParticipation: 'participación de la empresa',
        sections: {
          ABOUT: 'Acerca de la Inversión',
          DOCUMENTS: 'Documentos',
          KPI: 'Indicadores clave de rendimiento (KPI)',
          FOUNDERS: 'Fundadores',
          FORUM: 'Foro',
        },
        forum: {
          description:
            'Accede al foro para conversar y hacer preguntas con otros inversores y expertos',
          posts: 'Publicaciones',
          actions: {
            access: 'Acceder al Foro',
          },
          error: {
            signin: 'Necesitas estar autenticado para ver esta sección',
            cvm: {
              pending:
                'Estamos revisando tu perfil. Por favor espera. Recibirás actualizaciones por correo electrónico.',
              required: 'Necesitas completar tu perfil para continuar',
              actions: {
                goToCVM: 'Realizar verificación',
              },
              rejected:
                'Tu perfil no fue aprobado. Revisa tu correo electrónico para más detalles.',
            },
          },
        },
        actions: {
          invest: 'Invertir',
          seeProfile: 'Ver perfil en {{social}}',
          moreInfo: 'Más información',
        },
      },
      components: {
        drop: {
          remaining: 'Último artículo disponible',
          remaining_plural: '{{count}} artículos restantes',
          soldout: 'Todos los artículos han sido vendidos',
        },
        benefits: {
          title: 'Beneficios',
          subtitle: 'Consulta y gestiona tus beneficios',
          claim: 'Reclamar',
          claiming: 'Reclamando beneficio',
          expired: 'Beneficio expirado',
          claimed: 'Beneficio reclamado',
          expireIn: 'Expira en:',
          days_plural: '{{count}} días',
          days: '{{count}} día',
          remaining: '{{count}} artículo disponible',
          remaining_plural: '{{count}} artículos disponible',
          claimConfirmation: {
            title: 'Reclamar beneficio',
            actions: {
              claim: 'Reclamar beneficio',
            },
            success: {
              title: 'Beneficio reclamado!',
              description:
                'Próximamente recibirá instrucciones y más información sobre este reclamo en su correo electrónico registrado {{email}}',
              actions: {
                understood: 'Entiendo',
              },
              subtitle:
                '¿Está seguro de que desea reclamar este beneficio? <br/>Esta acción no se puede deshacer.',
              pending:
                'Esta transacción puede tardar unos minutos. Una vez que se confirme el canje, recibirá instrucciones y más información en su correo electrónico registrado <b>{{email}}</b>',
            },
            details: {
              title: 'Detalle de beneficio',
              details: 'Más detalles',
              actions: {
                claim: 'Reclamar beneficio',
              },
            },
          },
        },
        form: {
          dataStatus: {
            COMPLETE: 'Completado',
            INCOMPLETE: 'Incompleto',
            PENDING: 'Pendiente',
            ERROR: 'Error',
          },
        },
        galleryCard: {
          tokenEmitter: {
            totalVolume: 'Volumen total',
            projects: '{{count}} proyecto',
            projects_plural: '{{count}} proyectos',
          },
        },
      },
      generic: {
        noItemsFound: 'No se encontraron artículos',
        brandMotto: 'Esto es raro. Este es Rarum.',
        knowMore: 'Sepa mas',
        waitingAuthorization: 'Esperando confirmación',
        actions: {
          copy: 'Copiar',
        },
      },
      home: {
        banner: {
          v2: {
            brand: 'rarum',
            brandMotto: 'Community Engagement as a Service',
            brandBenefit: 'Valoramos lo que es raro: tu comunidad.',
            actions: {
              features: 'Descubre nuestra plataforma Whitelabel',
            },
          },
          title: `ACTIVOS DIGITALES <br/><span class="${Styles.gradient}">SUSTENTABLES Y PARA <br/>TODOS</span>`,
          subtitle:
            'Tenga un mercado de tokens personalizado para su comunidad',
          action: {
            create: '¡Crea tu tienda!',
          },
        },
        sections: {
          highlights: {
            title: 'Ofertas abiertas',
          },
          brand: {
            title: '100% Carbon Neutral',
            description: `Compensamos todas las emisiones de carbono de la plataforma y los activos negociados.

Rarum también opera en blockchains que son eficientes en sus emisiones de gases de efecto invernadero.`,
          },
          gallery: {
            heading: 'Descubre las Galerías Rarum',
            title: 'Últimas galerías',
            action: {
              seeAll: 'Ver todas las galerías',
            },
          },
          latest: {
            title: 'Tokens destacados',
            action: {
              seeAll: 'Ver todos',
            },
          },
          store: {
            title: 'Tiendas',
          },
          create: {
            title:
              '¡Crea tu propria galería o tienda y empieza a vender tus tokens!',
            actions: {
              knowMore: 'Sepa mas',
            },
            highlight: {
              create: 'Crea tus tokens',
              easy: 'Fácil de comprar y vender',
              secure: 'Seguro, transparente y carbon free',
            },
          },
          partnership: {
            title: 'Neutralidad de Carbono',
            description:
              'En nuestra búsqueda de prácticas más sostenibles, hemos reducido significativamente nuestras emisiones de carbono e implementado tecnologías blockchain de bajo impacto ambiental.',
            actions: {
              knowMore: 'Sepa mas',
            },
          },
          news: {
            title: 'Artículos',
          },
        },
      },
      allGalleries: {
        title: 'GALERÍAS',
        sections: {
          highlight: {
            title: 'Galerías destacadas',
          },
          createYourOwn: {
            title:
              'Crea tu propria galería o tienda y empieza a vender tus tokens?',
            action: {
              knowMore: 'Sepa mas',
            },
          },
        },
      },
      myCollection: {
        actions: {
          seeAllGallery: 'Mostrar todos',
          hideAllGallery: 'Volver a la lista',
        },
      },
      galleryDetails: {
        noMarket: 'Artículos de la galería',
        noAvailable: `Sigue visitando!
Luego tendremos nuevas ofertas en esta galería`,
        actions: {
          seeAllMarketplace: 'Ver todo en el mercado',
          seeAll: 'Ver todo los artículos',
        },
        expiredItems: 'Artículos cerrados',
        market: 'Artículos de mercado',
        items: 'Tokens',
      },
      topbar: {
        menus: {
          [MenuOptions.ABOUT]: 'ACERCA DE RARUM',
          [MenuOptions.FAQ]: 'FAQ',
          [MenuOptions.GALLERIES]: 'GALERÍAS',
          [MenuOptions.MARKET]: 'MERCADO',
          [MenuOptions.HOW_IT_WORKS]: 'CÓMO FUNCIONA',
          [MenuOptions.BRAND]: 'MARCAS',
          [MenuOptions.CREATORS]: 'CREADORES',
        },
        auth: {
          login: 'Iniciar sesión',
          signup: 'Crea tu cuenta',
        },
      },
      offer: {
        creation: {
          steps: {
            value: {
              price: {
                reference: 'Precio de referencia',
                min: 'Precio mínimo',
                max: 'Precio máximo',
              },
              cut: 'Porcentaje de la plataforma',
              receive: 'Recibirás',
            },
            payment: {
              disclaimer:
                'Actualmente, solo es posible comprar y vender en el mercado secundario a través de PIX',
              description:
                'Recibirás el monto después de que se complete la entrega',
              pix: {
                title: 'CLAVE PIX',
                description:
                  'Ingresa la clave PIX donde deseas recibir el monto de la venta',
                placeholder: 'CPF, correo electrónico, teléfono o clave PIX',
                disclaimer:
                  'La clave PIX proporcionada debe pertenecer al mismo titular de la cuenta confirmado en los datos financieros',
                error: {
                  invalid:
                    'La clave ingresada no coincide con el CPF registrado. Verifique los datos e inténtelo de nuevo.',
                },
              },
            },
            address: {
              title: 'Dirección de recogida',
              description:
                'Confirma o añade una dirección de origen para el envío del artículo después de la compra',
              actions: {
                addAddress: 'Añadir dirección',
              },
            },
            delivery: {
              title: 'Puntos de recogida más cercanos',
              actions: {
                enableLocation: 'Encontrar más cercanos',
              },
            },
            deliveryConfirmation: {
              origin: {
                title: 'Dirección de origen del artículo',
                description:
                  'Confirma la dirección de origen y consulta las transportadoras cercanas para el envío del artículo después de la compra',
              },
              postoffices: {
                title: 'Transportadoras cercanas',
                description:
                  'Consulta las transportadoras cercanas a la dirección proporcionada',
                action: {
                  seeOnMap: 'Ver en el mapa',
                },
              },
            },
            confirmation: {
              title:
                "Al hacer clic en 'Publicar anuncio', confirmas que estás de acuerdo con los <b color='secondary'><a href='{{{terms}}}' target='_blank'>términos de servicio</a></b>",
            },
            creating: {
              title: 'Publicando anuncio',
              routeChangeWarning: `El anuncio aún no ha sido publicado. Si sales ahora, es posible que el proceso de creación no se complete.
¿Estás seguro de que quieres salir?`,
              progress: {
                authorizing: 'Autorizando transferencia del artículo',
                creatingOffer: 'Creando oferta',
              },
            },
            created: {
              title: '¡Anuncio publicado con éxito!',
              description:
                'Gestiona y visualiza tus anuncios en el área "$t(pages.collections.tab.offers)", dentro de la sección "$t(components.router.tabs.closet)"',
            },
          },
        },
        buy: {
          steps: {
            address: {
              title: 'Dirección de entrega',
            },
          },
          loading: 'Estamos preparando tu pedido',
          progress: {
            authorizing: 'Autorizando transacción financiera',
            buyingOffer: 'Creando pedido',
          },
        },
      },
      tracking: {
        total: 'Total',
        number: 'Número de pedido',
        currentStatusTag: 'Estado actual',
        heading: {
          failed: 'Entrega fallida',
        },
        status: {
          title: 'Estado del pedido',
          seller: {
            label: {
              AWAITING_POST: '$t(tracking.status.buyer.label.AWAITING_POST)',
              PROCESSED: 'Artículo enviado',
              IN_TRANSIT: '$t(tracking.status.buyer.label.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.label.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.label.DELIVERED)',
              FAILED_AWAIT: '$t(tracking.status.buyer.label.FAILED_AWAIT)',
              DELIVERY_FAILED:
                '$t(tracking.status.buyer.label.DELIVERY_FAILED)',
              FAILED_COLLECT: '$t(tracking.status.buyer.label.FAILED_COLLECT)',
              FAILED_CONTACT: '$t(tracking.status.buyer.label.FAILED_CONTACT)',
              FAILED_RETURN: '$t(tracking.status.buyer.label.FAILED_RETURN)',
              PAYED: '$t(tracking.status.buyer.label.PAYED)',
            },
            detail: {
              TRACKING_INFO: '$t(tracking.status.buyer.detail.TRACKING_INFO)',
              TRACKING_N_CONTACT:
                '$t(tracking.status.buyer.detail.TRACKING_N_CONTACT)',
              AWAITING_POST: `Tienes hasta 7 días hábiles para realizar el envío en la oficina de correos.

Genera la etiqueta de envío y ve a la oficina de correos más cercana para completar el envío

{{generateTrackingBtn}}`,
              PROCESSED: '$t(tracking.status.buyer.detail.PROCESSED)',
              IN_TRANSIT: '$t(tracking.status.buyer.detail.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.detail.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.detail.DELIVERED)',
              DELIVERY_FAILED: 'Tuvimos un problema con la entrega.',
              FAILED_COLLECT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_CONTACT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_RETURN:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_AWAIT: '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
            },
          },
          buyer: {
            label: {
              AWAITING_POST: 'Esperando envío',
              PROCESSED: 'Artículo enviado por el vendedor',
              IN_TRANSIT: 'Artículo en tránsito',
              OUT_FOR_DELIVERY: 'Artículo en reparto',
              DELIVERED: 'Artículo entregado',
              FAILED_AWAIT: 'Intento de entrega fallido',
              DELIVERY_FAILED: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_COLLECT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_CONTACT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_RETURN: 'Devolviendo al vendedor',
              PAYED: 'Pago completado',
            },
            detail: {
              TRACKING_INFO:
                '\n\nCódigo de seguimiento:\n{{trackingCode}}\n\n{{trackBtn}}',
              TRACKING_N_CONTACT:
                '\n\nCódigo de seguimiento:\n{{trackingCode}}\n\n{{contactBtn}}',
              AWAITING_POST:
                '¡Tu pedido ha sido confirmado!\nEl vendedor enviará en un plazo de 7 días hábiles.\n\nRecibirás una notificación una vez que el pedido sea enviado.',
              PROCESSED:
                'Entrega estimada: {{- predictedDeliveryDate}}$t(tracking.status.detail.TRACKING_INFO)',
              IN_TRANSIT: '$t(tracking.status.detail.PROCESSED)',
              OUT_FOR_DELIVERY: 'Código de seguimiento:\n{{trackingCode}}',
              DELIVERED:
                'Entregado el {{- deliveryDate}}$t(tracking.status.detail.TRACKING_INFO)',
              DELIVERY_FAILED:
                'Espere el próximo intento de entrega, que se realizará el próximo día hábil.\nSi el cartero no es atendido en ninguno de los intentos, el artículo será enviado a la oficina de correos.$t(tracking.status.detail.TRACKING_INFO)',
              FAILED_COLLECT:
                'Tu pedido está disponible para recoger en la oficina de correos.\nContacta con la oficina de correos para más información.$t(tracking.status.detail.TRACKING_INFO)',
              FAILED_CONTACT:
                'Algo salió mal con tu entrega.\nContacta con nuestro soporte para más información.$t(tracking.status.detail.TRACKING_N_CONTACT)',
              FAILED_RETURN:
                'Tu pedido está siendo devuelto al vendedor.$t(tracking.status.detail.TRACKING_INFO)',
              FAILED_AWAIT:
                'Tuvimos un problema con la entrega. Lo estamos analizando y pronto proporcionaremos una actualización.$t(tracking.status.detail.TRACKING_N_CONTACT)',
            },
          },
          actions: {
            generateLabel: 'Generar etiqueta de envío',
          },
        },
        order: {
          details: 'Detalles del pedido',
          date: 'Fecha del pedido',
          value: 'Valor del artículo',
        },
        help: '¿Necesitas ayuda?',
        actions: {
          talkToUs: 'Habla con nosotros',
          track: 'Rastrear envío',
        },
      },
    },
  },
}

export default messages
